"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.boxShadow = void 0;

/**
 * Export `boxShadow`.
 */
var boxShadow = {
  card: '0 1px 5px rgba(25, 28, 30, 0.08)',
  dropdownMenu: '0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12)',
  modal: '0px 1px 3px rgba(25, 28, 30, 0.07)',
  toggle: '0 0 2px 3px rgba(0, 0, 0, 0.46)'
};
exports.boxShadow = boxShadow;